import React, { useEffect, useContext, useState } from 'react'
import {
  CheckCircleFilled,
  ClockCircleOutlined,
  CloseCircleFilled,
  ExclamationCircleFilled,
  LoadingOutlined,
  PauseCircleOutlined
} from '@ant-design/icons'
import { message, Modal, Spin, Tabs } from 'antd'
import axios from 'axios'
import TableSolicitudesByStatus from 'components/TableContainer/Solicitudes/TableSolicitudesByStatus'
import { useSolicitudes } from 'components/TableContainer/Solicitudes/hooks/useSolicitudes'
import { Navigate } from 'react-router-dom'
import { AppContext } from 'app/AppContext'
import { getAllRolePermissions, userHasPermission } from 'utils/userHasPermission'
import { CARGA_MASIVA, SOLICITUDES } from 'app_permissions/solicitudes'
import { SECTIONS } from 'utils/constantPermissions'

const { TabPane } = Tabs

const Solicitudes = () => {
  const [isRunningContractorImport, setIsRunningContractorImport] =
    useState(false)
  const requestArr = [
    {
      code: 'PPDD',
      name: 'Pendientes',
      Icon: () => <ExclamationCircleFilled />
    },
    { code: 'APVD', name: 'Aprobadas', Icon: () => <CheckCircleFilled /> },
    { code: 'RJTD', name: 'Rechazadas', Icon: () => <CloseCircleFilled /> },
    { code: 'FND', name: 'Finalizadas', Icon: () => <ClockCircleOutlined /> },
    { code: 'DSL', name: 'Absentismos', Icon: () => <PauseCircleOutlined /> }
  ]

  const { rolData, envConfig } = useContext(AppContext)
  const allPermissions = getAllRolePermissions(rolData)

  const hasSection = (sectionId) =>
    allPermissions?.some(
      (info) => Number(info.section_id) === Number(sectionId)
    )

  const VER_SOLICITUDES =
    userHasPermission(rolData?.role, SOLICITUDES.VISUALIZAR) ||
    hasSection(SECTIONS.Solicitudes)

  const EJECUTAR_CARGA_CONTRATISTAS = userHasPermission(
    rolData?.role,
    CARGA_MASIVA.CREAR
  )

  const { getDataRequest, dataRequest } = useSolicitudes('', requestArr)

  const spinIcon = (
    <LoadingOutlined
      style={{
        fontSize: 20
      }}
      spin
    />
  )

  useEffect(() => {
    getDataRequest()
  }, [])

  const executeContractorImport = () => {
    Modal.confirm({
      title: 'Ejecutar carga de contratistas',
      content:
        'Se consultarán los contratistas pendientes y se crearán sus solicitudes. ¿Deseas continuar?',
      okText: 'Ejecutar',
      cancelText: 'Cancelar',
      onOk: async () => {
        setIsRunningContractorImport(true)
        try {
          const { data } = await axios.post(
            `${process.env.REACT_APP_BASE_URL_REQUESTS}/cron-service/contractor-mass-import`,
            {},
            { params: { user: envConfig } }
          )

          if (data.skipped) {
            message.warning(
              'La carga ya está siendo ejecutada por otra instancia.'
            )
            return
          }

          const summary = `Encontrados: ${data.found}. Exitosos: ${data.succeeded}. Fallidos: ${data.failed}.`
          if (data.failed > 0) {
            message.warning(`Carga finalizada con observaciones. ${summary}`)
          } else {
            message.success(`Carga finalizada correctamente. ${summary}`)
          }
          await getDataRequest()
        } catch (error) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            'No fue posible ejecutar la carga de contratistas.'
          message.error(errorMessage)
          throw error
        } finally {
          setIsRunningContractorImport(false)
        }
      }
    })
  }

  if (!VER_SOLICITUDES) {
    return <Navigate to='/first-login' state={{ unauthorizedError: true }} />
  }

  return (
    <div className='solicitudes_container'>
      <Tabs type='card' tabBarGutter={10}>
        {requestArr.map(({ code, name, Icon }) => (
          <TabPane
            tab={
              <span className='title_tab'>
                <div>
                  <Icon />
                </div>

                {dataRequest[code]?.count !== undefined ? (
                  `(${dataRequest[code].count}) `
                ) : (
                  <Spin indicator={spinIcon} />
                )}
                {name}
              </span>
            }
            key={code}
          >
            <TableSolicitudesByStatus
              tableData={dataRequest[code]?.list}
              nPages={dataRequest[code]?.nPages}
              count={dataRequest[code]?.count}
              code_status={code}
              canExecuteContractorImport={EJECUTAR_CARGA_CONTRATISTAS}
              isRunningContractorImport={isRunningContractorImport}
              onExecuteContractorImport={executeContractorImport}
            />
          </TabPane>
        ))}
      </Tabs>
    </div>
  )
}

export default Solicitudes
